import { iArticleReference__API } from '../apiSchema';
import { iPublication } from './Publication';
import { iFile, mapFile__Api } from './File';
import { iTag } from './Tag';
import { iSubscriptionPackage } from './SubscriptionPackage';
import PublicationTypesEnum, { getPublicationType } from '../enums/PublicationTypesEnum';

interface iData {
    apiModel?: iArticleReference__API;
}

export class ArticleReference implements iPublication {
    id = 0;
    title = '';
    description = '';
    image = '';
    thumbnail = '';
    featuredImage = '';
    createdDate = '';
    createdDateToOrder = '';
    numberOfPages = 0;
    minutesToRead = 0;
    hasAccess = false;
    isLiked = false;
    isAddedToReadingList = false;
    tags: iTag[] = [];
    subscriptionPackages: iSubscriptionPackage[] = [];
    buttonCategoryId = 0;
    titleCategoryId = 0;
    publicationId = 0;
    publicationTitle = '';
    files: iFile[] = [];
    publicationType = PublicationTypesEnum.Publication;
    pages = undefined;

    constructor(data?: iData) {
        if (data && data.apiModel) {
            this.mapFromApi(data.apiModel);
        }
    }

    private mapFromApi(data: iArticleReference__API) {
        this.id = data.id || 0;
        this.title = data.title;
        this.image = data.imageUrl;
        this.thumbnail = data.imageUrl;
        this.featuredImage = data.imageUrl;
        this.createdDate = data.createDate;
        this.createdDateToOrder = data.createDate;
        this.hasAccess = data.hasAccess;
        this.files = data.files.map(mapFile__Api);
        this.publicationId = data.id || 0;
        this.publicationTitle = data.title;
        this.publicationType = getPublicationType(data.publicationType);
    }
}
